import { get, post } from '@/utils/request'

const diskApi = {
  createFolderApi: '/api/disk/folder/create',
  renameFolderApi: '/api/disk/folder/rename',
  getFolderTreeApi: '/api/disk/folder/tree',
  addFileApi: '/api/disk/file/add',
  deleteFileApi: '/api/disk/file/delete',
  moveFileApi: '/api/disk/file/move',
  diskFileApi: '/api/disk/file/list',
  filePreviewApi: '/api/disk/file/preview',
  getCamApi: '/api/disk/cam',
  createShareApi: '/api/disk/share/create',
  deleteShareApi: '/api/disk/share/delete',
  getShareListApi: '/api/disk/share/list',
  getShareToListApi: '/api/disk/share/user_list',
  submitUserActivityApi: '/api/disk/cam/activity',
  getCamRecordByMonthAPi: '/api/disk/cam/record/month',
  getRecordUrlAPi: '/api/disk/cam/record/url',
  getAlbumApi: '/api/disk/album',
  getAlbumListApi: '/api/disk/album/list',
  getDiskChannelInfoApi: '/api/file/oss/serverinfo/file'
}

export function createFolder(payload) {
  return post(diskApi.createFolderApi, payload)
}

export function renameFolder(payload) {
  return post(diskApi.renameFolderApi, payload)
}

export function getFolderTree() {
  return get(diskApi.getFolderTreeApi)
}

export function addFile(payload) {
  return post(diskApi.addFileApi, payload)
}

export function deleteFile(payload) {
  return post(diskApi.deleteFileApi, payload)
}

export function moveFile(payload) {
  return post(diskApi.moveFileApi, payload)
}

export function getDiskFile(query) {
  return get(diskApi.diskFileApi, query)
}

export function getPhotoItems(queryParams) {
  return get(diskApi.getAlbumApi + '/items', queryParams)
}

export function getFileDetail(fileId) {
  return get(diskApi.filePreviewApi + '?fileId=' + fileId)
}

export function getDiskChannelInfo() {
  return post(diskApi.getDiskChannelInfoApi)
}

export function getAlbumList(pn) {
  return get(diskApi.getAlbumListApi + '?pn=' + pn)
}

export function createShare(payload) {
  return post(diskApi.createShareApi, payload)
}

export function deleteShare(shareId) {
  return post(diskApi.deleteShareApi + '/' + shareId)
}

export function getShareList(pn) {
  return get(diskApi.getShareListApi + '?pn=' + pn)
}

export function getShareToList(shareId) {
  return get(diskApi.getShareToListApi + '?shareId=' + shareId)
}

export function getCamList() {
  return get(diskApi.getCamApi + '/list')
}

export function getCamDetail(query) {
  return get(diskApi.getCamApi + '/detail', query)
}

export function getRecordByMonth(query) {
  return get(diskApi.getCamRecordByMonthAPi, query)
}
export function getRecordUrl(recordId) {
  return get(diskApi.getRecordUrlAPi + '/' + recordId)
}

export function submitActivity() {
  return post(diskApi.submitUserActivityApi)
}
